import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8">
      <div className="container mx-auto px-4 text-center">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-white mb-2">Invoice Generator Pro</h3>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Create professional invoices instantly. Free, fast, and secure invoice generator 
            for freelancers, small businesses, and consultants.
          </p>
        </div>
        
        <div className="border-t border-gray-800 pt-6">
          <p className="text-sm text-gray-500">
            © 2025 Invoice Generator Pro. All rights reserved.
          </p>
          <p className="text-xs text-gray-600 mt-2">
            Made with ❤️ for small businesses and freelancers worldwide
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;